module.exports = __webpack_public_path__ + "static/media/SHREECEM.1c09eccf.txt";